export default function inStringColumn() {
    return {
        restrict: 'E',
        scope: {
            value: '&'
        },
        template: '<span>{{ value() }}</span>'
    };
}

inStringColumn.$inject = [];



// WEBPACK FOOTER //
// ./app/components/common/crud/column/inStringColumn.js